/**
 * @file: 链表
 * @author: xiaolong.huang@dmall.com
 */

class LinkedNode {
    val: any;
    next: LinkedNodeInstance|null;
    prev: LinkedNodeInstance|null;

    constructor(val: any) {
        this.val = val;
        this.next = null;
        this.prev = null;
    }
};

class LinkedList {
    length: number = 0;
    head: LinkedNodeInstance = null;
    extendParams: FreeObjMap = {};

    getElementAt(position: number): LinkedNodeInstance|null {
        if (position < 0 || position >= this.length) {
            return null;
        };

        let current: LinkedNodeInstance|null = this.head;

        for (let i = 0; i < position; i++) {
            current = current.next;
        }

        return current;
    }

    append(val: any): void {
        let node: LinkedNodeInstance = new LinkedNode(val);

        if (this.head === null) {
            this.head = node;
        }
        else {
            let current: LinkedNodeInstance = this.getElementAt(this.length - 1);

            current.next = node;
            node.prev = current;
        }

        this.length++;
    }

    remove(val: any): void {
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            if (current.val === val) {
                if (i === 0) {
                    this.head = current.next;
                    if (current.next) {
                        current.next.prev = null;
                    }
                    this.length--;
                    break;
                }
                current.prev.next = current.next;
                this.length--;
                break;
            };
            current = current.next;
        }
    }

    findNext(val: any): LinkedNodeInstance|null {
        let node: LinkedNodeInstance|null = this.findNode(val);

        if (node === null) {
            return null;
        }

        return node.next;
    }

    findPrev(val: any): LinkedNodeInstance|null {
        let node: LinkedNodeInstance|null = this.findNode(val);

        if (node === null) {
            return null;
        }

        return node.prev;
    }

    findNode(val: any): LinkedNodeInstance|null {
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            if (current.val === val) {
                return current;
            };
            current = current.next;
        }

        return null;
    }

    indexOf(val: any): number {
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            if (current.val === val) {
                return i;
            };
            current = current.next;
        }

        return -1;
    }

    value(): string {
        let current: LinkedNodeInstance = this.head;
        let value: string = '';

        for (let i = 0; i < this.length; i++) {
            value += current.val;
            current = current.next;
        }

        return value;
    }

    walk(callback: (val: any, index: number) => void): void {
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            callback(current.val, i);
            current = current.next;
        }
    }

    walkNode(callback: (val: any, index: number) => void): void {
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            callback(current, i);
            current = current.next;
        }
    }

    valueList(): any[] {
        let result: any[] = [];
        let current: LinkedNodeInstance = this.head;

        for (let i = 0; i < this.length; i++) {
            result.push(current.val);
            current = current.next;
        }

        return result;
    }

    has(val: any): boolean {
        return this.findNode(val) !== null;
    }

    behindOf(val: any): any[] {
        let result: any[] = [];
        let node: LinkedNodeInstance|null = this.findNode(val);
        let current: LinkedNodeInstance = node ? node.next : null;

        while(current) {
            result.push(current.val);
            current = current.next;
        }

        return result;
    }

    beforeOf(val: any): any {
        let result: any[] = [];
        let node: LinkedNodeInstance|null = this.findNode(val);
        let current: LinkedNodeInstance = node ? node.prev : null;

        while(current) {
            result.push(current.val);
            current = current.prev;
        }

        return result;
    }

    findLastNode(): LinkedNodeInstance|null {
        let current: LinkedNodeInstance = this.head;

        while(current && current.next) {
            current = current.next;
        }

        return current;
    }

    findFirstNode(): LinkedNodeInstance|null {
        return this.head;
    }

    isHead(val: any): boolean {
        return this.head.val === val;
    }

    isLast(val: any): boolean {
        let lastNode: LinkedNodeInstance|null = this.findLastNode();

        return lastNode && lastNode.val === val;
    }
}

export default LinkedList;
